import { Page } from 'layouts/Page';
import { FC } from 'react';
import { VATReport } from 'components/VATReport-old';
import { Gpsr } from 'components/Gpsr';

export const GpsrPage: FC = () => {
	return (
		<Page title="GPSR Management – EAS Control Center">
			<Gpsr />
		</Page>
	);
};
